import { Img } from 'react-image';
import axios from 'axios';

import React from 'react';
class Media extends React.Component {
  constructor(props) {
    super(props);
    let idstr = props.src;
    idstr = idstr.split('/');
    let base = tmp_path.temp_uri;

    this.state = {
      base: tmp_path.temp_uri,
      spsrc: base + '/dist/assets/images/' + props.src + '-sp' + '.webp',
      sp: props.sp,
      src: base + '/dist/assets/images/' + props.src + '.webp',
      alt: props.alt,
      class: props.class ? props.class : '',
      class_picture: props.pClass ? props.pClass+' '+props.class+'__wrap' : props.class+'__wrap',
      state: props.state ? props.state : '',
      id: idstr,
    }
  }
  
  componentDidMount() {
    axios
      .get(tmp_path.site_url+"/wp-json/wp/v2/custom/medias/?id="+this.state.id[0]+"_"+this.state.id[1])
      .then(response => {
        this.setState({
          src: response.data[0].src ? response.data[0].src : this.state.src,
          spsrc: response.data[0].sp ? response.data[0].sp : this.state.spsrc,
          sp: response.data[0].sp ? 'sp' : this.props.sp,
        });
      })
      .catch(error => console.log(error));
  }

  render() {
    if(this.state.id[0] == 'flow') {
      // console.log(this.state.spsrc)
    }
    let sp;
    if(this.state.sp) {
      sp = (
        <source
          id={'media_'+this.state.id[0]+'_'+this.state.id[1]+'_sp'}
          media="(max-width: 1080px)"
          srcSet={ this.state.spsrc }
        />
      )
    }
    return(
      <picture 
        id={'media_'+this.state.id[0]+'_'+this.state.id[1]}
        className={this.state.class_picture}
        data-state={this.state.state}
      >
        { sp }
        <Img
          id={'media_'+this.state.id[0]+'_'+this.state.id[1]}
          className={this.state.class}
          src={ this.state.src }
          alt={this.state.alt} />
      </picture>
    )
  }
}

export default Media;
